<div class="radio">
  <div *ngFor="let item of items" [ngClass]="{checked: selected==item.id}" (click)="select(item.id)">
    {{item.name}}
  </div>
</div>